<template>
  <div
    class="componentBox"
    draggable="true"
    @drop.stop="handleColsDragover"
    @dragover.prevent
    :id="'swiperBox' + myid.container_id + myid.rect_id + pageContent.swiperContent_id"
    @mouseenter="mouseenterEv"
    @mouseleave="mouseleaveEv"
  >
    <div v-if="pageContent.elementOptions.length===0 && !isBigScreenPreview()" class="empty-rect-tip">从左侧工具栏拖拽添加模块</div>
    <vueDragResizable
      ref="vdr"
      v-for="elementOptions in pageContent.elementOptions"
      :key="'layoutComponent' + elementOptions.elementInSwiperId + elementOptions.innerElement"
      :class="[`container_id_${myContentId.container_id}-rect_id_${myContentId.rect_id}-swiperContent_id_${myContentId.swiperContent_id}-elementInSwiperId_${elementOptions.elementInSwiperId}`, elementOptions.isActive ? 'active' : '']"
      :swiperContent_id="`${myContentId.swiperContent_id}`"
      :data-elementIds="JSON.stringify({ ...myContentId, elementInSwiperId: elementOptions.elementInSwiperId })"
      :data-shape="elementOptions.innerElement"
      :parentW="getParentW"
      :parentH="getParentH"
      :options="elementOptions"
      :w="Number(elementOptions.width)"
      :h="Number(elementOptions.height)"
      :x="Number(elementOptions.left)"
      :y="Number(elementOptions.top)"
      :uid="null"
      :elementInLayoutId="elementOptions.elementInSwiperId"
      :elementName="elementOptions.innerElement"
      :active="elementOptions.isActive && isElementInSwiper"
      :isShowModuleHandles="false"
      :rectId="myContentId.rect_id"
      :shape="elementOptions.innerElement"
      :swiperContentId="myContentId.swiperContent_id"
      v-on:activated="activeEv"
      v-on:resizeStop="resizestopEv"
      v-on:delElement="delElementEv"
      v-on:dragging="draggingEv(elementOptions, $event)"
      v-on:dragStop="dragstopEv(elementOptions, $event)"
      :zoom="zoom"
      :resizable="checkResizable(elementOptions)"
      :handles="checkHandles(elementOptions)"
      :myId="
        Object.assign(
          { ...myid },
          { swiperContent_id: pageContent.swiperContent_id, elementInSwiperId: elementOptions.elementInSwiperId }
        )
      "
    >
      <component
        style="height: 100%"
        class="rect"
        :myid="
          Object.assign(
            { ...myid },
            { swiperContent_id: pageContent.swiperContent_id, elementInSwiperId: elementOptions.elementInSwiperId }
          )
        "
        :is="elementOptions.innerElement"
        :options="elementOptions"
      ></component>
    </vueDragResizable>
    <!--辅助线-->
    <span
      class="ref-line v-line"
      v-for="item in vLine"
      :key="item.id"
      v-show="item.display"
      :style="{
        left: item.position,
        top: item.origin,
        height: item.lineLength
      }"
    >
    </span>
    <span
      class="ref-line h-line"
      v-for="item in hLine"
      :key="item.id"
      v-show="item.display"
      :style="{
        top: item.position,
        left: item.origin,
        width: item.lineLength
      }"
    >
    </span>
    <!--辅助线END-->
    <topSettingBtn
      :ref="pageContent.swiperContent_id + 'topSettingBtn'"
      v-if="!this.isBigScreenPreview() && options.isDraggable"
      :isActiveCol="isActiveCol"
      @activeCol="colsClickEv"
      :ids="ids"
      :myid="myid"
      :options="options"
      :pageContent="pageContent"
      :swiperContent_id="pageContent.swiperContent_id"
      @reSetComponent="reSetComponent"
    />
  </div>
</template>

<script>
import { Loading } from "element-ui"
import { _throttle } from "utils"
import componentsMixin from "./componentsMixin"
import { _debounce } from "utils"
import topSettingBtn from "./topSettingBtn.vue"
export default {
  name: "swiper-layoutComponent-preview",
  mixins: [componentsMixin],
  components: { topSettingBtn },
  props: {
    pageContent: {
      type: Object
    },
    options: {
      type: Object,
      default: null
    },
    showBigImg: {
      type: [Boolean, undefined]
    },
    zoom: {
      type: Number,
      default: 1
    },
    myid: {
      type: Object
    },
    isDraggable: {
      type: Boolean
    }
  },
  data() {
    return {
      bigImgShow: true,
      bigImgSrc: "",
      stageWidth: null,
      stageHeight: null,
      getParentW: null,
      getParentH: null,
      tempEl: null,
      loadInstance: null,
      vLine: [],
      hLine: [],
      myContentId: {
        ...this.myid,
        swiperContent_id: this.pageContent.swiperContent_id
      }
    }
  },
  watch: {
    pageContent: {
      deep: true,
      handler(o, n) {
        if (this.$el.offsetWidth !== 0) this.getParentW = this.$el.offsetWidth
        if (this.$el.offsetHeight !== 0) this.getParentH = this.$el.offsetHeight
      }
    },
    ids: {
      deep: true,
      handler(n, o) {
        if (this.options.isDraggable && n.swiperContent_id !== this.pageContent.swiperContent_id) {
          this.$refs[this.pageContent.swiperContent_id + "topSettingBtn"].hiddenSetting()
        }
        // 取消选择轮播后，要把所有元素置为非激活状态
        if(n.rect_id !== this.myid.rect_id) {
          this.clearAllActive()
        }
      }
    },
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    isElementInSwiper() {
      return this.ids.hasOwnProperty("elementInSwiperId")
    },
    isActiveCol() {
      if(this.options.activeCol === undefined && this.ids.swiperContent_id === undefined || this.options.activeCol === "") return false
      return this.options.activeCol === this.pageContent.swiperContent_id
    },
    getColsBorder() {
      return {
        outline: this.isActiveCol ? "1px solid var(--themeColor)" : "none"
      }
    },
  },
  mounted() {
    this.initVDRSize()
  },
  methods: {
    reSetComponent() {
      this.$emit("reSetComponent")
    },
    resizestopEv(rect, elementInSwiperId, uid, direction) {
      const ids = { ...this.ids }
      ids.elementInSwiperId = elementInSwiperId
      const content_name = ["width", "height"]
      const val = [rect.width, rect.height]
      this.$changeOptionsEV(val, content_name, false, null, ids, true)
    },
    draggingEv(opt) {
      // this.enableDragging && this.dragstopEv(...arguments)
    },
    isMyId(oldId, newId) {
      if (oldId.container_id !== newId.container_id) return false
      if (oldId.rect !== newId.rect) return false
      if (oldId.swiperContent_id !== newId.swiperContent_id) return false
      if (oldId.elementInSwiperId !== newId.elementInSwiperId) return false
      return true
    },
    setMyActive(opt) {
      const oldId = { ...this.ids }
      const newId = { ...this.myid }
      newId.swiperContent_id = this.pageContent.swiperContent_id
      newId.elementInSwiperId = opt.elementInSwiperId
      if (this.$store.state.states.elementType !== opt.innerElement) {
        this.$store.commit("states/changeElementType", opt.innerElement)
      }
      if (opt.isActive === false) {
        this.$store.dispatch(this.request_prefix + "/changeElementInSwiperActive", newId)
      }
      if (!this.isMyId(oldId, newId)) {
        this.$store.commit("states/changeActiveID", newId)
      }
    },
    isSamePosition(opt, rect) {
      return opt.left === rect.left && opt.top === rect.top
    },
    dragstopEv: _throttle(function (opt, _rect, elementInSwiperId, uid) {
      if(!this.isDraggable) return
      if (this.isSamePosition(opt, _rect)) return
      this.setMyActive(opt)
      if (typeof elementInSwiperId !== "number") {
        elementInSwiperId = opt.elementInSwiperId
      }
      const ids = { ...this.myid }
      const rect = { ..._rect }
      ids.swiperContent_id = this.pageContent.swiperContent_id
      ids.elementInSwiperId = elementInSwiperId
      let content_name = ["left", "top"]
      let val = [rect.left, rect.top]
      this.$changeOptionsEV(val, content_name, false, null, ids, true)
    }, 100),
    delElementEv(args, elementInSwiperId, uid) {
      const ids = { ...this.ids }
      this.$store.commit("states/changeActiveID", {
        container_id: ids.container_id,
        rect_id: ids.rect_id
      })
      ids.elementInSwiperId = elementInSwiperId
      this.$store.commit("states/changeElementType", "swiperComponent")
      if (this.$store.state.states.toolBarStatus) this.$store.commit("states/changeToolBarStatus", false)
      this.$store.dispatch(this.request_prefix + "/delComponentInSwiper", ids)
    },
    handleColsDragover(e, id) {
      let attribute = e.dataTransfer.getData("rectAttribute")
      if (attribute) {
        attribute = JSON.parse(attribute)
        //禁止往轮播组件里拖入自由布局组件
        if (attribute.shape.toLowerCase().includes("layout") || attribute.shape === "cxDataGrid") return
        //获取当前鼠标的left和top 不需要除zoom了
        let [left, top] = [e.offsetX, e.offsetY]
        ;[attribute.options.left, attribute.options.top] = [left, top]
        attribute.options.isActive = false
        let param = {
          ...this.myContentId,
          elementOptions: attribute.options
        }
        this.$store.dispatch(this.request_prefix + "/addComponentInSwiper", param)
      }
    },
    clickEv(elementOptions) {
      console.log("this.showBigImg :>> ", this.showBigImg)
      if (!this.showBigImg) return
      this.loadInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.8)",
        spinner: "swiper_big_img"
      })
      const self = this
      requestAnimationFrame(() => {
        const body = window.getComputedStyle(document.body)
        const bodyW = Number(body.getPropertyValue("width").slice(0, -2))
        const bodyH = Number(body.getPropertyValue("height").slice(0, -2))
        const maskEl = document.querySelector(".el-loading-mask")
        const imgEl = document.createElement("div")
        maskEl.style.display = "flex"
        maskEl.style.alignItems = "center"
        maskEl.style.justifyContent = "center"
        imgEl.setAttribute("class", "swiper_big_img")
        imgEl.style.backgroundImage = `url("${elementOptions.imgSrc}")`
        imgEl.style.width = (elementOptions.width * 2 > bodyW ? bodyW : elementOptions.width * 2) + "px"
        imgEl.style.height = (elementOptions.height * 2 > bodyH ? bodyH : elementOptions.height * 2) + "px"
        imgEl.style.backgroundRepeat = elementOptions.repeatType
        imgEl.style.backgroundSize = elementOptions.clipSize
        imgEl.style.backgroundPosition = elementOptions.alignType
        maskEl.appendChild(imgEl)
        imgEl.addEventListener("click", this.loadingClose)
      })
    },
    activeEv(elementInSwiperId, index, shape) {
      // const changeId = {
      //   ...this.myContentId
      // }
      // this.$store.commit("states/changeActiveID", changeId)
      // this.$store.commit("states/changeElementType", shape)
      // if (!this.$getOptions(changeId).isActive) this.$store.dispatch(this.request_prefix + "/setActive", changeId)
      //将当前自由布局组件的选中单元格id设为当前单元格
      // this.setCurrColAsActiveCol()
      // this.clicked(null, elementInSwiperId, uid, options)
    },
    clicked(ev, elementInSwiperId, uid, options) {
      window.localStorage.setItem(
        "tempOffsetPosition",
        JSON.stringify({
          offsetTop: this.$el.offsetTop,
          offsetLeft: this.$el.offsetLeft
        })
      )
      setTimeout(this.handdleChangeActiveInLayout(elementInSwiperId, uid, options), 100)
      //外部组件中设置active的方法有延迟，需要等待一下
    },
    //处理轮播组件中元素选中效果
    handdleChangeActiveInLayout(elementInSwiperId, uid, options) {
      const activeID = {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id,
        uid: uid,
        elementInLayoutId: elementInSwiperId,
        path: options.path
      }
      this.$store.commit("states/changeActiveID", activeID)
    },
    initVDRSize() {
      if (this.$el.offsetWidth !== 0) this.getParentW = this.$el.offsetWidth
      if (this.$el.offsetHeight !== 0) this.getParentH = this.$el.offsetHeight
    },
    checkResizable(rect) {
      return rect.resizable
    },
    checkHandles() {
      return ["tl", "tm", "tr", "mr", "br", "bm", "bl", "ml"]
    },
    setCurrColAsActiveCol() {
      if (this.options.activeCol !== this.pageContent.swiperContent_id) {
        this.$changeOptionsEV(this.pageContent.swiperContent_id, "activeCol", false, null, {
          container_id: this.myid.container_id,
          rect_id: this.myid.rect_id
        })
      }
    },
    mouseenterEv() {
      if (
        !this.$store.state.states.alignHelperStatus &&
        !localStorage.getItem("multipleComponent") &&
        !localStorage.getItem("preventMouseenterEv")
      ) {
        //将当前自组件的选中单元格id设为当前单元格
        this.setCurrColAsActiveCol()
      }
    },
    mouseleaveEv() {
      this.$nextTick(() => {
        if (this.options.activeCol === this.pageContent.swiperContent_id) {
          this.$changeOptionsEV("", "activeCol", false, null, {
            container_id: this.myid.container_id,
            rect_id: this.myid.rect_id
          })
        }
      })
    },
    colsClickEv() {
      // if (this.isBigScreenPreview()) return
      // this.inColsEv()
    },
    inColsEv() {
      this.clearAllActive()
    },
    clearAllActive() {
      if (this.pageContent.elementOptions.find(it => it.isActive)) {
        const clearActive = {
          ...this.myid,
          swiperContent_id: this.pageContent.swiperContent_id,
          elementInSwiperId: null
        }
        this.$store.dispatch(this.request_prefix + "/changeElementInSwiperActive", clearActive)
      }
    },
    loadingClose(e) {
      this.loadInstance.close()
      e.target.removeEventListener("click", this.loadingClose)
    }
  }
}
</script>
<style>
</style>
<style scoped>
.big_img_preview {
  position: fixed;
  width: 100%;
  height: 100%;
  background: red;
}
.componentBox {
  width: 100%;
  height: 100%;
  position: relative;
}
.ref-line {
  position: absolute;
  background-color: rgb(255, 0, 204);
  z-index: 9999;
}

.v-line {
  width: 1px;
}

.h-line {
  height: 1px;
}
.empty-rect-tip{
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--thirdTextColor);
}
</style>
